module.exports = __webpack_public_path__ + "img/banner-dire.4af3e789.jpg";